import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCarFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 11.5V17.5C22.5 18.8807 21.3807 20 20 20C18.7654 20 17.7398 19.1051 17.5366 17.9286H6.46341C6.26016 19.1051 5.23459 20 4 20C2.61929 20 1.5 18.8807 1.5 17.5V11.5H0.75C0.335786 11.5 0 11.1642 0 10.75C0 10.3358 0.335786 10 0.75 10H1.83431L4.48275 5.7625C5.16802 4.66607 6.36978 4 7.66274 4H16.3373C17.6302 4 18.832 4.66607 19.5173 5.7625L22.1657 10H23.25C23.6642 10 24 10.3358 24 10.75C24 11.1642 23.6642 11.5 23.25 11.5H22.5ZM5 13.0357C5 12.6215 5.33579 12.2857 5.75 12.2857H7.75C8.16421 12.2857 8.5 12.6215 8.5 13.0357C8.5 13.4499 8.16421 13.7857 7.75 13.7857H5.75C5.33579 13.7857 5 13.4499 5 13.0357ZM15.5 13.0357C15.5 12.6215 15.8358 12.2857 16.25 12.2857H18.25C18.6642 12.2857 19 12.6215 19 13.0357C19 13.4499 18.6642 13.7857 18.25 13.7857H16.25C15.8358 13.7857 15.5 13.4499 15.5 13.0357Z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCarFilled);
export default ForwardRef;
